import React from "react";
import {
  RiAttachmentLine,
  RiCameraLine,
  RiFileList3Line,
  RiPencilLine,
  RiPenNibLine,
} from "react-icons/ri";
import { numberToPorcent } from "../../../../../../../../../../../utils/mask";

export const tableColumnsConsolidado = (handleRedirectWithFilter: any) => [
  {
    id: "nome",
    label: "Consultor",
  },
  {
    id: "quantidade",
    label: "Qtde",
  },
  {
    id: "mei",
    label: "MEI",
  },
  {
    id: "me",
    label: "ME",
  },
  {
    id: "epp",
    label: "EPP",
  },
  {
    id: "na",
    label: "NA",
  },
  {
    id: "porcentagemMei",
    label: "%MEI",
    customField: numberToPorcent,
  },
  {
    id: "semAnotacoes",
    label: "Sem Anotações",
    customLabel: () =>
      (
        <span style={{ cursor: "help" }} title={"Sem anotações"}>
          <RiPencilLine size={15} color="#8F90A6" />
        </span>
      ) as any,
    customField: (value: any, data: any) => (
      <div onClick={() => handleRedirectWithFilter(data, "anotacao", false)}>
        <p
          style={{
            textDecoration: value ? "underline" : "none",
            color: value ? "#0061C6" : "#555770",
            cursor: value ? "pointer" : "initial",
          }}
        >
          {value ?? 0}
        </p>
      </div>
    ),
  },
  {
    id: "semOrientacoes",
    label: "Sem Orientações",
    customLabel: () =>
      (
        <span style={{ cursor: "help" }} title={"Sem Orientações"}>
          <RiFileList3Line size={15} color="#8F90A6" />
        </span>
      ) as any,
    customField: (value: any, data: any) => (
      <p
        onClick={() => handleRedirectWithFilter(data, "planoAcao", false)}
        style={{
          textDecoration: value ? "underline" : "none",
          color: value ? "#0061C6" : "#555770",
          cursor: value ? "pointer" : "initial",
        }}
      >
        {value ?? 0}
      </p>
    ),
  },
  {
    id: "semFotos",
    label: "Sem Fotos",
    customLabel: () =>
      (
        <span style={{ cursor: "help" }} title={"Sem Fotos"}>
          <RiCameraLine size={15} color="#8F90A6" />
        </span>
      ) as any,
    customField: (value: any, data: any) => (
      <p
        onClick={() => handleRedirectWithFilter(data, "foto", false)}
        style={{
          textDecoration: value ? "underline" : "none",
          color: value ? "#0061C6" : "#555770",
          cursor: value ? "pointer" : "initial",
        }}
      >
        {value ?? 0}
      </p>
    ),
  },
  {
    id: "semAssinaturas",
    label: "Sem Assinaturas",
    customLabel: () =>
      (
        <span style={{ cursor: "help" }} title={"Sem Assinaturas"}>
          <RiPenNibLine size={15} color="#8F90A6" />
        </span>
      ) as any,
    customField: (value: any, data: any) => (
      <p
        onClick={() => handleRedirectWithFilter(data, "assinatura", false)}
        style={{
          textDecoration: value ? "underline" : "none",
          color: value ? "#0061C6" : "#555770",
          cursor: value ? "pointer" : "initial",
        }}
      >
        {value ?? 0}
      </p>
    ),
  },
  {
    id: "semAnexos",
    label: "Sem Anexos",
    customLabel: () =>
      (
        <span style={{ cursor: "help" }} title={"Sem Anexos"}>
          <RiAttachmentLine size={15} color="#8F90A6" />
        </span>
      ) as any,
    customField: (value: any, data: any) => (
      <p
        onClick={() => handleRedirectWithFilter(data, "anexo", false)}
        style={{
          textDecoration: value ? "underline" : "none",
          color: value ? "#0061C6" : "#555770",
          cursor: value ? "pointer" : "initial",
        }}
      >
        {value ?? 0}
      </p>
    ),
  },
];
